export type TClinicGalleryQueryParams = {
  mode?: string;
  limit?: number;
  cursor?: string | null;
  timezone?: string;
  includePatientInfo?: boolean;
  uploadTypes?: readonly string[];
};

export const buildClinicGallerySearchParams = (
  params: TClinicGalleryQueryParams,
) => {
  const searchParams = new URLSearchParams();

  if (params.mode) searchParams.append("mode", params.mode);
  if (params.limit) searchParams.append("limit", params.limit.toString());
  if (params.cursor) searchParams.append("cursor", params.cursor);
  if (params.timezone) searchParams.append("timezone", params.timezone);
  if (params.includePatientInfo) {
    searchParams.append("include_patient_info", "true");
  }
  params.uploadTypes?.forEach((uploadType) => {
    searchParams.append("upload_types", uploadType);
  });

  return searchParams;
};
